import React from 'react';
import { COMPANY_PHONE } from '../../utils/constants';

// Shown when a member is authenticated with Firebase but loginCheck could not
// load their account (e.g. no matching record in our database). This is an
// account problem the member can't resolve themselves, so we tell them to call
// customer service rather than showing the generic "must be registered" prompt,
// which misleadingly implies they simply lack access to the page.
export const AccountError = () => {
  const telHref = `tel:${COMPANY_PHONE.replace(/[^\d]/g, '')}`;

  return (
    <div className="flex items-center justify-center width-full height-full py-24 md:py-48 lg:py-96">
      <div className="flex flex-col max-w-2xl">
        <h2 className="text-center uppercase text-l text-darkBlue mb-4">
          There&apos;s a problem with your account
        </h2>
        <p className="text-center text-base">
          We couldn&apos;t load your membership details. Please contact customer
          service at{' '}
          <a className="text-darkBlue underline" href={telHref}>
            {COMPANY_PHONE}
          </a>{' '}
          and we&apos;ll get this sorted out for you.
        </p>
      </div>
    </div>
  );
};
